import React, { Component } from 'react';
import { APP_CONST } from '../../../../../../constants';
import { GeckoFields, GeckoBtn, Label } from '../../../../../../components';
import { CircleCheckBig } from 'lucide-react';
import IntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';

export class PhoneNumberRequired extends Component {
    state = {
        valid: false,
        raw_value: null,
        meta: {},
        formated_value: null,
    }

    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.handleChangeFlag = this.handleChangeFlag.bind(this);
        this.submit = this.submit.bind(this);
    }

    handleChange(valid, raw_value, meta, formated_value) {
        this.setState({
            valid: valid,
            raw_value: raw_value,
            meta: meta,
            formated_value: formated_value,
        });
    }

    handleChangeFlag(raw_value, meta, formated_value, valid) {
        this.setState({
            valid: valid,
            raw_value: raw_value,
            meta: meta,
            formated_value: formated_value,
        });
    }

    submit() {
        if (!this.state.formated_value || this.state.formated_value === '') {
            return;
        }

        if (!this.state.valid) {
            this.props.setAlert('Invalid mobile phone number');
            return;
        }

        // remove spaces and dashes
        let number = this.state.formated_value;
        number = number.split(' ').join('');
        number = number.split('-').join('');

        return this.props.submit(number);
    }

    render() {
        return (
            <div>
                <p className="text-sm text-foreground mb-4">You must provide your mobile number before setting up two factor authentication.</p>

                <form className="gecko-fields">
                    <div className="form-group">
                        <div className="gecko-field flex flex-col gap-1 mb-4">
                            <Label htmlFor="field_phone_number">Mobile phone number</Label>
                            <div className="w-full [&_.intl-tel-input]:w-full">
                                <IntlTelInput
                                    containerClassName="intl-tel-input"
                                    inputClassName="w-full file:text-foreground placeholder:text-slate-500 selection:bg-primary selection:text-primary-foreground border-input flex h-10 w-full min-w-0 rounded-sm border bg-transparent px-3 py-1 text-base transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-slate-50 disabled:text-foreground md:text-sm focus-visible:border-slate-500 focus-visible:ring-slate-400/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive"
                                    onPhoneNumberChange={this.handleChange}
                                    onSelectFlag={this.handleChangeFlag}
                                />
                            </div>
                        </div>
                    </div>
                </form>
                <div className="text-xs text-muted-foreground mb-4">
                    <p className="mb-2">
                        By signing up for SMS Multi-Factor Authentication (MFA), you agree to receive SMS messages for verification purposes. Your phone number will be stored in accordance with our <a href="https://geckoengage.com/privacy-policy/" target="_blank">Privacy Policy</a>. Your number will only be used for sending SMS verification messages, which will be sent each time you log in to Gecko. Message and data rates may apply.
                    </p>
                    <p className="mb-2">
                        To stop receiving these messages, you can disable MFA at any time here in your account settings. For any questions or assistance, please <a href="https://academy.geckoengage.com/en/articles/6701795-how-do-i-contact-gecko-support" target="_blank" className="text-muted-foreground underline hover:text-foreground">contact Gecko Support</a>.
                    </p>
                </div>
                <div>
                    <GeckoBtn 
                        name={'Save number'}
                        icon={CircleCheckBig}
                        type={APP_CONST.BTN_TYPE_PRIMARY}
                        className={'savePhoneNumberButton'}
                        handler={this.submit}
                    />
                </div>
            </div>
        );
    }
}

PhoneNumberRequired.defaultProps = {
    submit: () => null,
    setAlert: () => null,
}

export default PhoneNumberRequired;